import { Outlet } from "react-router";

import { LanguageSelect, ProjectLogo } from "@/components/common";

import { AuthBanner } from "./AuthBanner";

export const AuthLayout = () => {
  return (
    <div className="h-screen min-h-screen w-full items-stretch px-4 py-9 lg:p-7 flex flex-col md:flex-row bg-new-background gap-9 md:gap-6 relative">
      <div className="flex md:hidden w-full justify-between items-center">
        <ProjectLogo />
        <LanguageSelect size="md" />
      </div>
      <AuthBanner className="hidden md:flex md:flex-1" />
      <div className="md:flex-1 md:h-full flex items-center justify-center">
        <Outlet />
      </div>
      <div className="absolute right-7 bottom-7 hidden md:block">
        <LanguageSelect size="md" />
      </div>
    </div>
  );
};
